import { datadogRum } from "@datadog/browser-rum";

export const initDatadogCatchError = () => {
  // Catch all javascript global errors
  window.onerror = (message, source, lineno, colno, error) => {
    datadogRum.addError(message, {
      source: source,
      lineno: lineno,
      colno: colno,
      errorStack: error ? error.stack : null,
    });

    // Allow to continue the default behavior
    return true;
  };

  // Catch all promises un handle rejections
  window.onunhandledrejection = (event) => {
    datadogRum.addError(event.reason.message, {
      stack: event.reason.stack || "No stack available",
    });
  };
};
